import { useEffect, useRef } from 'react';
import { Heart } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import { trackPurchase } from '@/lib/gtm';

export default function PaymentSuccessPage() {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');

    // Track purchase event (only once)
    const hasTrackedPurchase = useRef(false);
    useEffect(() => {
        if (!hasTrackedPurchase.current) {
            trackPurchase(sessionId || undefined);
            hasTrackedPurchase.current = true;
        }
    }, [sessionId]);

    return (
        <div className="flex items-center justify-center min-h-[calc(100vh-180px)]">
            <div className="flex flex-col items-center gap-5 max-w-[560px] px-4">
                <div className="flex items-center justify-center w-10 h-10 bg-foreground rounded-full">
                    <Heart className="w-4 h-4 text-white fill-white" />
                </div>

                <div className="flex flex-col items-center gap-3 text-center">
                    <h1 className="text-[28px] leading-[1.1]">
                        Subscription confirmed! You now have unlimited access to all features
                    </h1>
                    <p className="text-base leading-[1.5] text-foreground/70">
                        Return to the dashboard to continue using ByLLMs.
                    </p>
                </div>

                <Link
                    to="/dashboard"
                    className="flex items-center justify-center h-14 px-5 bg-primary rounded text-white font-mono font-medium text-sm tracking-[0.7px] uppercase hover:opacity-90 transition-opacity"
                >
                    Back to dashboard
                </Link>
            </div>
        </div>
    );
}
